module.exports = __webpack_public_path__ + "img/military_base-gallery-5.ef0e36b2.jpg";